module.exports = __webpack_public_path__ + "img/wqs.55ddd593.jpg";